import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { PlantasDTO } from "src/app/models/plantas.dto";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class PlantasService extends CrudService<PlantasDTO> {
  protected controller: string = "settings/plantas/";
}
